import {Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {FormBuilder, NG_VALUE_ACCESSOR} from "@angular/forms";
import {filter, finalize, takeUntil, tap} from "rxjs/operators";
import {FormControlBaseComponent} from "../../../shared/components/form-controls/form-control-base/form-control-base.component";
import {AddSingleFormatToCartForm} from "../../../shared/forms/add-single-format-to-cart.form";
import {AddSingleFormatToCartModel} from "../../../shared/models/cart/add-single-format-to-cart.model";
import {PriceCalculationResultModel} from "../../../shared/models/cart/price-calculation-result.model";
import {ProductFormatModel} from "../../../shared/models/product/product-format.model";
import {ProductCartService} from "../../../shared/services/product/product-cart.service";
import {ProductModel} from "../../../shared/models/product/product.model";

@Component({
  selector: "[pcg-ng-product-line]",
  template: require('./product-line.component.html'),
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ProductLineComponent), multi: true}
    ],
})
export class ProductLineComponent extends FormControlBaseComponent<AddSingleFormatToCartModel> implements OnInit, OnDestroy {
    private _isLocked: boolean;

    @Input() public product: ProductModel;

    @Output() public removeClick: EventEmitter<number> = new EventEmitter();

    public selectedFormat: ProductFormatModel = null;

    public productForm: AddSingleFormatToCartForm;

    public totalPrice: string;

    public get isLocked(): boolean {
        return this._isLocked;
    }

    public constructor(
        private formBuilder: FormBuilder,
        private productCartService: ProductCartService,
    ) {
        super(new AddSingleFormatToCartModel(1));
    }

    public ngOnInit(): void {
        const formControlModel = new AddSingleFormatToCartModel(this.product.id);
        this.productForm = AddSingleFormatToCartForm.createForm(this.formBuilder, formControlModel);

        this.productForm.changeObservable
            .pipe(takeUntil(this.destroy$))
            .subscribe(model => this.handleChange(model));
        this.productForm.validityObservable
            .pipe(takeUntil(this.destroy$))
            .subscribe(model => this.handleValidity(model));

        this.setDefaultFormat();
    }

    private handleChange(model: AddSingleFormatToCartModel): void {
        this.lock();
        this.clearPrice();
        this.selectedFormat = null;

        this.productCartService.calculatePriceBySingleFormat(model)
            .pipe(
                filter(this.productForm.validate),
                finalize(() => {
                    this.unLock();
                    this.writeNewValue(this.productForm.getModel());
                }),
                takeUntil(this.destroy$)
            )
            .subscribe(result => this.processCalculationResult(model, result));
    }

    public handleRemoveClick(): void {
        this.removeClick.emit();
    }

    private processCalculationResult(model: AddSingleFormatToCartModel, result: PriceCalculationResultModel): void {
        this.totalPrice = result.totalPrice;

        this.product.formats = result.formats;
        this.productForm.handleFormatsUpdate(this.product.formats);

        const formatId = parseInt(model.format, 10);
        this.selectedFormat = this.product.formats.find(x => x.id === formatId);
    }

    private handleValidity = (isValid: boolean): void => {
        if(!isValid) {
            this.clearPrice();
        }
    }

    private clearPrice(): void {
        this.totalPrice = "";
    }

    private lock(): void {
        this._isLocked = true;
    }

    private unLock(): void {
        this._isLocked = false;
    }

    private setDefaultFormat(): void {
        if (this.product.formats && this.product.formats.length === 1) {
            this.selectedFormat = this.product.formats[0];
            this.productForm.format.setValue(this.selectedFormat.id.toString());
        }
    }
}
